export interface FirmaDigital {
  tipo: 'texto' | 'imagen';
  valor: string; // nombre escrito o base64 de imagen
}

export interface CartaSolicitud {
  id: string;
  proyectoCodigo: string;
  proyectoTitulo: string;
  investigadorNombre: string;
  investigadorEmail: string;
  investigadorCargo: string;
  investigadorUnidad: string;
  ciudad: string;
  fecha: string;
  cuerpo: string;
  firma: FirmaDigital | null;
  estado: 'borrador' | 'enviada' | 'leida';
  fechaEnvio: string | null;
  notificadoComite: boolean;
}

export const cartasMock: CartaSolicitud[] = [
  {
    id: 'carta-001',
    proyectoCodigo: 'PRY-2026-001',
    proyectoTitulo: 'Impacto de la telemedicina en zonas rurales',
    investigadorNombre: 'Dra. María Solano',
    investigadorEmail: 'maria.solano@universidad.edu',
    investigadorCargo: 'Docente Investigadora',
    investigadorUnidad: 'Facultad de Ciencias de la Salud',
    ciudad: 'Quito',
    fecha: '2026-03-08',
    cuerpo: 'Por medio de la presente, me dirijo a ustedes con el fin de solicitar la evaluación del proyecto de investigación titulado "Impacto de la telemedicina en zonas rurales", el cual ha sido desarrollado bajo los lineamientos establecidos por el Vicerrectorado de Investigación.\n\nEl proyecto tiene como objetivo principal evaluar la efectividad de plataformas de telemedicina en reducir barreras de acceso a salud en zonas rurales de difícil acceso, contribuyendo así al desarrollo científico y social de nuestra institución.\n\nAdjunto a la presente carta, encontrarán el formulario de recepción debidamente completado, junto con los documentos de respaldo requeridos por el Comité.\n\nAgradezco de antemano la atención prestada y quedo a disposición para cualquier consulta o información adicional que requieran.',
    firma: { tipo: 'texto', valor: 'Dra. María Solano' },
    estado: 'leida',
    fechaEnvio: '2026-03-08T10:30:00.000Z',
    notificadoComite: true,
  },
];

export const PLANTILLA_CARTA = `Por medio de la presente, me dirijo a ustedes con el fin de solicitar la evaluación del proyecto de investigación titulado "{TITULO_PROYECTO}", el cual ha sido desarrollado bajo los lineamientos establecidos por el Vicerrectorado de Investigación.

El proyecto tiene como objetivo principal {OBJETIVO_PROYECTO}, contribuyendo así al desarrollo científico y social de nuestra institución.

Adjunto a la presente carta, encontrarán el formulario de recepción debidamente completado, junto con los documentos de respaldo requeridos por el Comité de Investigación e Interacción.

Solicito respetuosamente que el proyecto sea considerado para su evaluación en la próxima sesión del Comité, de acuerdo con los procedimientos establecidos en el Reglamento de Investigación Institucional.

Agradezco de antemano la atención prestada y quedo a disposición para cualquier consulta o información adicional que requieran.

Atentamente,`;

export const MIEMBROS_COMITE = [
  { nombre: 'Dr. Roberto Ortega', email: 'rortega@upal.edu', cargo: 'Presidente del Comité' },
  { nombre: 'Dra. Ana Villacís', email: 'avillacis@upal.edu', cargo: 'Secretaria Académica' },
  { nombre: 'Mg. Luis Paredes', email: 'lparedes@upal.edu', cargo: 'Vocal Investigación' },
  { nombre: 'Dra. Patricia Mora', email: 'pmora@upal.edu', cargo: 'Vocal Interacción' },
];
